'use strict';

import * as angular from 'angular';
import * as moment from 'moment-timezone';
import * as util from './util/property-util';

export const nocRun = /*@ngInject*/ ["$rootScope", "$cookies", "ProjectResourceService", "LoginService", "$translate", "tmhDynamicLocale", "RedirectService", "ProjectCookieFactory", "StateManagerFactory", "ProjectService", "AuthenticationFactory", "ErrorLogger", "$state", "LocaleFactory", "TimeZoneFactory", "TrainCacheService", "ConfigService", "ConfigurationResourceService", "ProjectConfigurationService", "ConfigurationStoreService",
 function($rootScope, $cookies, ProjectResourceService, LoginService, $translate, tmhDynamicLocale, RedirectService, ProjectCookieFactory, StateManagerFactory, ProjectService, AuthenticationFactory, ErrorLogger, $state, LocaleFactory, TimeZoneFactory, TrainCacheService, ConfigService, ConfigurationResourceService, ProjectConfigurationService, ConfigurationStoreService) {

    $rootScope.currentUser = null;
    $rootScope.debug = false;
    var projectConfigurationSubscription;

    ProjectService.subscribe("NOC", function (id) {
        if (id === 0) {
            let selectedProjectIds =  ProjectCookieFactory.getProjectId();
            selectedProjectIds = selectedProjectIds ? selectedProjectIds.split(',') : [];
            for (let index = 0; index < selectedProjectIds.length; index++) {
                const projectId = selectedProjectIds[index];
                projectConfigurationSubscription = ProjectConfigurationService.getProjectConfiguration(projectId).subscribe(function(result) {
                    var configuration = result && result.data;
                    if (configuration) {
                        ConfigurationStoreService.setProjectConfiguration(projectId, configuration);
                    }
                });
            }

        } 
        projectConfigurationSubscription = ProjectConfigurationService.getProjectConfiguration(id).subscribe(function(result) {
                var configuration = result && result.data;
                if (configuration) {
                    ConfigurationStoreService.setProjectConfiguration(id, configuration);
                }
                
        });
        
      
        TrainCacheService.update(id);
        $rootScope.selectedProject = {};
        $rootScope.selectedProject.id = id;
        $rootScope.currentUser = AuthenticationFactory.getUser();
        if ($rootScope.currentUser) {
            $rootScope.fullname = $rootScope.currentUser.fullname;
        }
        
        $rootScope.today = new Date();

    });

    $rootScope.$on("localeChanged", () => {
        var language = $cookies.get('nomad.noc.ng.language');;
        tmhDynamicLocale.set(language).then(function () {
            // Set the language in angular-translate
            $translate.use(language);
            moment.locale(language);
        });

    });


    $rootScope.logError = function (error, id) {
        ErrorLogger.logError(error, id);
    };

    $rootScope.isAdmin = function () {
        return AuthenticationFactory.isAdmin();
    };
    $rootScope.isLoggedIn = function () {
        return AuthenticationFactory.getUserState().isLoggedIn;
    };
    $rootScope.cleanAndUpdateUserState = function () {
        AuthenticationFactory.removeUserTrace();
        AuthenticationFactory.resetUserState();
    };

    $rootScope.getState = function () {
        "use strict";
        return $state;
    };

    $rootScope.logout = function () {
        $rootScope.currentUser = null;
        AuthenticationFactory.logout();
        projectConfigurationSubscription && projectConfigurationSubscription.dispose();
    };

}];